import { Route, Routes } from 'react-router'
import { useEffect } from 'react'

import PageNotFound from 'views/components/page-not-found'
import { facialRoutes } from './routes'

export const InfluencerRouter = () => {
  useEffect(() => {
    document.title = 'Book A Facial'
  }, [])
  return (
    <Routes>
      {facialRoutes.map((route) => {
        return (
          <Route
            path={route.path}
            element={route.component}
            key={route.key}
            caseSensitive={true}
          />
        )
      })}
      <Route key="404" path="*" element={<PageNotFound />} />
    </Routes>
  )
}
